export default __webpack_public_path__ + "static/media/icons-project-bidding.f71769f2.svg";